import Awb from "../models/Awb";
import AwbParams from "../models/AwbParams";

const AWB_SCHEMA: Awb = {
  airline_code: '',
  arrival_date: '',
  code: '',
  delivered: false,
  destination: '',
  attachments_count: 0,
  due: 0,
  screened: false,
  edited: false,
  flight_no: '',
  id: 0,
  id_forwarder: 0,
  id_gha_org: 0,
  id_gha_dst: 0,
  id_gha_interline: 0,
  version: 0,
  number: '',
  origin: '',
  import_parts: [{
    id: '',
    arrival_date: '',
    flight_date: '',
    delivered: false,
    pieces: 0,
    received: false,
    tableData: { id: 0 },
    weight: '',
    flight_no: '',
    status: '',
    not_delivered_pieces: 0,
    not_delivered_weight: 0
  }],
  export_parts: [{
    id: '',
    arrival_date: '',
    flight_date: '',
    delivered: false,
    pieces: 0,
    received: false,
    tableData: { id: 0 },
    weight: '',
    flight_no: '',
    status: '',
    not_delivered_pieces: 0,
    not_delivered_weight: 0
  }],
  pieces: 0,
  received: false,
  validation: [{
    code: '',
    element: '',
    text: '',
  }],
  weight: '',
  status: '',
  export_metadata: {
    ccsf: false,
    shipperName: '',
    comodityType: '',
    shipperProfile: '',
    firstFlightDate: '',
    firstFlightNumber: ''
  },
  org: '',
  dst: '',
  allowed_ops: {
    update_awb: true,
    add_awb_cart: true,
    add_awb_truck: true,
    add_part: true,
    is_returned: false
  },
  manually_entered: true
};

function extractAwbCodeAndNumber(awbNo: string): AwbParams {
  
  const awbData: Array<string> = awbNo.split('-');
  const awbCode: string = awbData[0];
  const awbNumber: string = awbData[1];
  const version: number = awbData[2] ? Number(awbData[2]): 1;
  return { awbCode, awbNumber, version };
}

export {
  AWB_SCHEMA,
  extractAwbCodeAndNumber
}